import { render, staticRenderFns } from "./NotSablonForm.vue?vue&type=template&id=0ded4f50"
import script from "./NotSablonForm.vue?vue&type=script&lang=ts"
export * from "./NotSablonForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports